module.exports = "./img/a3685a59e08829eba69c1024008b000d.png";